import { useState } from "react";
import AdminCard from "./AdminCard";

interface Props { onSave: () => void; }

const defaultStats = [
  { icon: "ri-percent-line", value: "10.00%", label: "Target Per Annum", sub: "Monthly distributions" },
  { icon: "ri-calendar-event-line", value: "5 Years", label: "Investment Term", sub: "With rollover option" },
  { icon: "ri-building-2-line", value: "UK", label: "Asset Location", sub: "Assisted living properties" },
  { icon: "ri-shield-check-line", value: "1st", label: "Legal Charge Security", sub: "Independent trustee held" },
];

const defaultCTAStats = [
  { value: "10.00% p.a.", label: "Target Return" },
  { value: "Monthly", label: "Income Frequency" },
  { value: "5 Years", label: "Investment Term" },
  { value: "1st Charge", label: "Asset Security" },
];

export default function AdminStats({ onSave }: Props) {
  const [stats, setStats] = useState(defaultStats);
  const [ctaStats, setCtaStats] = useState(defaultCTAStats);
  const [sectionTitle, setSectionTitle] = useState("The Numbers That Matter");
  const [sectionSub, setSectionSub] = useState("A transparent, structured product designed to deliver consistent monthly income from UK social housing assets.");

  const updateStat = (i: number, k: string, v: string) => {
    setStats((prev) => prev.map((s, idx) => idx === i ? { ...s, [k]: v } : s));
  };
  const updateCTA = (i: number, k: string, v: string) => {
    setCtaStats((prev) => prev.map((s, idx) => idx === i ? { ...s, [k]: v } : s));
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-[#071A2E]" style={{ fontFamily: "'Playfair Display', serif" }}>Key Stats Section</h1>
        <p className="text-slate-500 text-sm mt-1">Edit the 4 key investment metric cards and the CTA section stats strip.</p>
      </div>

      <AdminCard title="Section Header">
        <div className="space-y-4">
          <div>
            <label className="block text-xs font-semibold text-slate-600 mb-1.5">Section Title</label>
            <input value={sectionTitle} onChange={(e) => setSectionTitle(e.target.value)} className="w-full border border-slate-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#C9A84C]" />
          </div>
          <div>
            <label className="block text-xs font-semibold text-slate-600 mb-1.5">Section Subtitle</label>
            <textarea value={sectionSub} onChange={(e) => setSectionSub(e.target.value)} rows={2} className="w-full border border-slate-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#C9A84C] resize-none" />
          </div>
        </div>
      </AdminCard>

      <AdminCard title="4 Metric Cards">
        <div className="space-y-5">
          {stats.map((s, i) => (
            <div key={i} className="bg-slate-50 rounded-xl p-4 border border-slate-100">
              <p className="text-xs font-bold text-slate-500 mb-3">Card {i + 1}</p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <div>
                  <label className="block text-xs font-semibold text-slate-600 mb-1">Value</label>
                  <input value={s.value} onChange={(e) => updateStat(i, "value", e.target.value)} className="w-full border border-slate-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#C9A84C]" />
                </div>
                <div>
                  <label className="block text-xs font-semibold text-slate-600 mb-1">Label</label>
                  <input value={s.label} onChange={(e) => updateStat(i, "label", e.target.value)} className="w-full border border-slate-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#C9A84C]" />
                </div>
                <div className="sm:col-span-2">
                  <label className="block text-xs font-semibold text-slate-600 mb-1">Sub-label</label>
                  <input value={s.sub} onChange={(e) => updateStat(i, "sub", e.target.value)} className="w-full border border-slate-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#C9A84C]" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </AdminCard>

      <AdminCard title="CTA Section Stats Strip">
        <div className="space-y-4">
          {ctaStats.map((s, i) => (
            <div key={i} className="grid grid-cols-2 gap-3 bg-slate-50 rounded-xl p-3 border border-slate-100">
              <div>
                <label className="block text-xs font-semibold text-slate-600 mb-1">Value</label>
                <input value={s.value} onChange={(e) => updateCTA(i, "value", e.target.value)} className="w-full border border-slate-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#C9A84C]" />
              </div>
              <div>
                <label className="block text-xs font-semibold text-slate-600 mb-1">Label</label>
                <input value={s.label} onChange={(e) => updateCTA(i, "label", e.target.value)} className="w-full border border-slate-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#C9A84C]" />
              </div>
            </div>
          ))}
        </div>
      </AdminCard>

      <div className="flex justify-end">
        <button onClick={onSave} className="flex items-center gap-2 px-6 py-3 rounded-xl bg-[#071A2E] text-white text-sm font-semibold hover:bg-[#0D2B4A] transition-colors cursor-pointer whitespace-nowrap">
          <i className="ri-save-line leading-none" />
          Save Changes
        </button>
      </div>
    </div>
  );
}
